import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { Box, Grid } from '@mui/material';
import FiltersContainerComponent from 'components/Filters/FiltersContainerComponent';
import Pod from 'components/Dashboard/PodContainer';
import { filters as filterStateSelector } from 'features/filtersState';
import LocalForageService from 'services/LocalForageService';

interface DashboardProps {
  dashboardId: string;
  permissions: Array<string>;
  filters: Array<any>;
  pods: Array<any>;
}

const DashboardView: React.FC<DashboardProps> = ({
  filters,
  pods,
  dashboardId,
}) => {
  const [loading, setLoading] = useState<boolean>(true);
  const filtersState = useSelector(filterStateSelector);
  const lsService = new LocalForageService();

  useEffect(() => {
    let allFiltersLoaded = true;
    let loadedFilters = 0;
    filters?.forEach((filter) => {
      if (
        filter.cascadeParentFilters === undefined ||
        filter.cascadeParentFilters.length === 0
      ) {
        loadedFilters += 1;
      }
      filter.cascadeParentFilters?.forEach((parentFilterId) => {
        const parentFilter = filtersState.find(
          (f) => f.filterId === parentFilterId && f.dashboardId === dashboardId
        );
        if (
          parentFilter &&
          parentFilter.selectedValues &&
          parentFilter.selectedValues.length > 0 &&
          parentFilter.loaded
        ) {
          loadedFilters++;
        }
      });
    });
    if (loadedFilters !== (filters.length || 0)) {
      allFiltersLoaded = false;
    }

    if (allFiltersLoaded) {
      setLoading(false);
    }
  }, [filtersState, filters, dashboardId, loading]);

  const refreshPod = () => {
    pods.map((pod) =>
      lsService.removeItem(`pod_data_${dashboardId}_${pod.podId}`)
    );
    setLoading(true);
  };

  return (
    <>
      <Box className="dashboard-view-container">
        <Grid
          className="dashboard-view-pods-container"
          container
          spacing={1}
          rowSpacing={1}
        >
          <Grid item xs={12}>
            <FiltersContainerComponent
              dashboardId={dashboardId}
              initialFilters={filters}
              refreshPod={refreshPod}
            />
          </Grid>
          {loading ? (
            <div>Loading...</div>
          ) : (
            <Grid
              className="dashboard-view-pods-container subGrid"
              container
              spacing={1}
              rowSpacing={1}
            >
              {pods.map((pod) => (
                <Grid item xs={pod.gridSize} key={pod.podId}>
                  <Pod pod={pod} dashboardId={dashboardId}></Pod>
                </Grid>
              ))}
            </Grid>
          )}
        </Grid>
      </Box>
    </>
  );
};

export default DashboardView;
